<template>
   <v-layout align-start>
      <v-flex>
         <v-snackbar
            v-model="snackbar"
            :color="snackColor"
            :right="true"
            :bottom="true"
            :timeout="4000"
         >
            {{ snackText }}
            <template #action="{ attrs }">
               <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                  Cerrar
               </v-btn>
            </template>
         </v-snackbar>

         <v-toolbar flat color="white">
            <v-toolbar-title class="text-h5 font-weight-medium">
               Estadísticas de Pagos
            </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <CustomDatePicker
               :date="fecha"
               label="Fecha"
               min="2015-01-01"
               :max="hoy"
               txt-style="width: 160px;"
               @updateFecha="fecha = $event"
            />
            <v-btn
               class="ml-3"
               color="primary"
               depressed
               :loading="loading"
               @click="cargarEstadisticas"
            >
               <v-icon left small>fas fa-search</v-icon>
               Buscar
            </v-btn>
         </v-toolbar>

         <v-divider></v-divider>

         <!-- CARDS DE RESUMEN -->
         <v-container fluid>
            <v-row>
               <!-- Total pagos -->
               <v-col cols="12" sm="6" md="4" lg="2">
                  <v-card color="primary" dark class="pa-3 text-center">
                     <div class="text-h3 font-weight-bold">{{ estadisticas.totalPagos }}</div>
                     <div class="text-subtitle-1">Total pagos</div>
                  </v-card>
               </v-col>

               <!-- Monto total -->
               <v-col cols="12" sm="6" md="4" lg="2">
                  <v-card color="teal darken-1" dark class="pa-3 text-center">
                     <div class="text-h5 font-weight-bold">$ {{ montoTotalFormateado }}</div>
                     <div class="text-subtitle-1">Monto total</div>
                  </v-card>
               </v-col>

               <!-- Cuotas -->
               <v-col cols="12" sm="6" md="4" lg="2">
                  <v-card color="blue darken-1" dark class="pa-3 text-center">
                     <div class="text-h3 font-weight-bold">{{ estadisticas.cantCuotas }}</div>
                     <div class="text-subtitle-1">Cuotas</div>
                  </v-card>
               </v-col>

               <!-- Cuotas beca -->
               <v-col cols="12" sm="6" md="4" lg="2">
                  <v-card color="purple darken-1" dark class="pa-3 text-center">
                     <div class="text-h3 font-weight-bold">{{ estadisticas.cantCuotasBeca }}</div>
                     <div class="text-subtitle-1">Cuotas con beca</div>
                  </v-card>
               </v-col>

               <!-- Aranceles -->
               <v-col cols="12" sm="6" md="4" lg="2">
                  <v-card color="orange darken-1" dark class="pa-3 text-center">
                     <div class="text-h3 font-weight-bold">{{ estadisticas.cantAranceles }}</div>
                     <div class="text-subtitle-1">Aranceles</div>
                  </v-card>
               </v-col>
            </v-row>

            <!-- TABLA DE DESGLOSE POR ARANCEL -->
            <v-row class="mt-4">
               <v-col cols="12">
                  <v-card class="elevation-1">
                     <v-card-title class="text-subtitle-1 font-weight-medium">
                        Desglose por arancel
                     </v-card-title>
                     <v-data-table
                        dense
                        :mobile-breakpoint="0"
                        :headers="headersDesglose"
                        :items="estadisticas.desglose || []"
                        :loading="loading"
                        loading-text="Cargando datos, por favor espere ..."
                        no-data-text="Sin pagos para la fecha seleccionada"
                        disable-pagination
                        hide-default-footer
                        class="mytable"
                     >
                        <template #item.montoTotal="{ item }">
                           $ {{ numFormatIntl(item.montoTotal) }}
                        </template>
                        <template #body.append>
                           <tr v-if="estadisticas.totalPagos > 0">
                              <td class="font-weight-bold">Total</td>
                              <td class="text-center font-weight-bold">{{ estadisticas.totalPagos }}</td>
                              <td class="text-right font-weight-bold">$ {{ montoTotalFormateado }}</td>
                           </tr>
                        </template>
                     </v-data-table>
                  </v-card>
               </v-col>
            </v-row>
         </v-container>
      </v-flex>
   </v-layout>
</template>

<script>
import axios from 'axios'
import { authComputed } from '../helpers.js'
import formatters from '../mixins/formattersLib'
import CustomDatePicker from './custom/CustomDatePicker.vue'

export default {
   name: 'EstadisticasPagos',
   components: { CustomDatePicker },
   mixins: [formatters],
   data: (vm) => ({
      fecha: vm.toISOLocal(new Date()).substr(0, 10),
      hoy: vm.toISOLocal(new Date()).substr(0, 10),
      estadisticas: {
         totalPagos: 0,
         montoTotal: 0,
         cantCuotas: 0,
         cantCuotasBeca: 0,
         cantAranceles: 0,
         desglose: []
      },
      loading: false,
      snackbar: false,
      snackColor: 'primary',
      snackText: '',
      headersDesglose: [
         { text: 'Arancel / Concepto', value: 'arancel', class: 'titulo' },
         { text: 'Cantidad', value: 'cantidad', align: 'center', class: 'titulo' },
         { text: 'Monto total', value: 'montoTotal', align: 'right', class: 'titulo' }
      ]
   }),
   computed: {
      ...authComputed,
      montoTotalFormateado() {
         return this.numFormatIntl(this.estadisticas.montoTotal || 0)
      }
   },
   created() {
      if (this.permController(2, 'ver')) {
         this.cargarEstadisticas()
      } else {
         this.$router.push({ name: 'inicio' })
      }
   },
   methods: {
      numFormatIntl(value) {
         return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
         }).format(value)
      },
      cargarEstadisticas() {
         this.loading = true
         axios
            .get('api/Pago/estadisticas?fecha=' + this.fecha + '&botonDePagoId=1')
            .then((response) => {
               this.estadisticas = response.data
            })
            .catch(() => {
               this.snackText = 'Error al cargar las estadísticas'
               this.snackColor = 'error'
               this.snackbar = true
            })
            .finally(() => {
               this.loading = false
            })
      }
   }
}
</script>
